module.exports = "/_next/static/images/logo-bg-6ea203bd649cf5dff291d90b80e08533.png";